import React, {useEffect} from 'react';
import {Button} from "antd";
import Header from "../../../components/Header";
import CompanyCard from "../../../components/CompanyCard";
import useApi from "../../../hooks/useApi";
import Authorized from "../../../components/Authorized";
import useHistory from "../../../hooks/useHistory";

const Profile = (props) => {
    const {id} = props;

    const {load, firstTimeFetched, response} = useApi();
    const company = response.data || {};
    const history = useHistory()

    useEffect(() => {
        load({
            endpoint: `/companies/${id}`,
        })
    }, [id, load])

    const pushToEditProfile = () => {
        history.push(`/profile/edit`);
    }

    return (
        <div style={{flex: 1}}>
            <Header title="Profil"
                    extra={
                        <Authorized type="company-profile" params={{username: company.username}}>
                            <Button type="link" onClick={pushToEditProfile}>Düzenle</Button>
                        </Authorized>
                    }/>
            <CompanyProfileCard company={company}
                                isLoading={!firstTimeFetched}
            />
        </div>
    )
}

const CompanyProfileCard = props => {
    const {company, isLoading} = props;
    return <CompanyCard company={company} isLoading={isLoading}/>
}

export default Profile
